<template>
  <div class="card-faqs">
    <div class="card-faqs__text">
      <h3>{{ faq.question }}</h3>
      <p>{{ faq.answer }}</p>
    </div>
    <div class="card-faqs-btns">
      <button type="button" class="btn__edit" @click="handleEdit()">
        <img
          class="img-fluid"
          src="@/assets/img/btn-edit.png"
          alt="icon edit"
          title="icon edit"
        />
      </button>
      <button type="button" class="btn__remove" @click="handleDelete()">
        <img
          class="img-fluid"
          src="@/assets/img/btn-excluir.png"
          alt="icon delete"
          title="icon delete"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    faq: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions("ContentPages", ["removeContentFaq"]),
    handleEdit() {
      this.$emit("edit-faq", this.faq);
      this.$bvModal.show("modal-faqs");
    },
    handleDelete() {
      this.$swal
        .fire({
          html: `Tem certeza que deseja deletar a <b>FAQ</b>
        <b style=" display: block; font-size: 24px; color: #EF0000;">${this.faq.question}?</b>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#EF0000",
          confirmButtonText: "SIM",
          cancelButtonText: "NÃO",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.removeContentFaq(this.faq);
            this.$swal.fire({
              icon: "success",
              html: `<b>FAQ</b><b style=" display: block; font-size: 24px; color: #EF0000;">${this.faq.question}?</b> removido com sucesso!`,
            });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.card-faqs {
  padding: 20px 15px 10px 15px;
  background: var(--white);
  border-radius: 15px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  &__text {
    text-align: left;
    h3 {
      font-size: 16px;
      font-family: "Font Semibold";
      color: var(--black);
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      margin-bottom: 10px;
    }
    p {
      font-size: 14px;
      font-family: "Font Light";
      color: var(--black);
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      overflow: hidden;
      margin-bottom: 0;
    }
  }
  &-btns {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
    .btn__edit,
    .btn__remove {
      background: 0;
      border: 0;
      padding: 0;
      transition: 500ms;
      &:hover,
      &:focus {
        cursor: pointer;
        opacity: 0.6;
      }
    }
    .btn__edit {
      margin-right: 5px;
    }
  }
}
</style>
